import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ShimmerGFX',
  props: {
    width: { type: Number, required: true },
    height: { type: Number, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();




const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})